export const USStates = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

// RESIDENT CENTER SECTION (HIDDEN AT THIS MOMENT).
export const ResidentCenterServicesAndDocDummy = {
  recommendedServices: [
    {
      id: "0001",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 1",
    },
    {
      id: "0002",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 2",
    },
    {
      id: "0003",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 3",
    },
    {
      id: "0004",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 4",
    },
    {
      id: "0005",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 5",
    },
    {
      id: "0006",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 6",
    },
    {
      id: "0007",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 7",
    },
  ],
  cleaningServices: [
    {
      id: "0008",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 8",
    },
    {
      id: "0009",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 9",
    },
    {
      id: "0010",
      imageUrl: require("@Assets/images/event_no_image_placeholder.jpeg"),
      title: "American Asian Woman Association 10",
    },
  ],
  documentation: [
    {
      title: "Map of Districts",
      link: "~~ASSET_STORAGE_BASE_URL~~/20200113_LWR_CDD_Map_mf6.pdf",
    },
  ],
};

const servicesHtmlDescription = `<div><div>We’re very sorry to communicate that ......<br />
Courts must be booked in advance with a minimum of 24 hours notice and can be done so by emailing: xx@xx.com</div>
<br />
<strong>Open Hours:</strong>
<div>Tue — Sat</div>
<div>7 AM - 7 PM</div></div>`;

// RESIDENT CENTER SECTION (HIDDEN AT THIS MOMENT).
export const ResidentCenterServiceDetailDummy = [
  {
    id: "0001",
    type: "Service",
    title: "American Asian Woman Association 1",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: "Services",
  },
  {
    id: "0002",
    type: "Service",
    title: "American Asian Woman Association 2",
    openDates: "Mon, Tue, Fri",
    description: servicesHtmlDescription,
    tag: "Services",
  },
  {
    id: "0003",
    type: "Service",
    title: "American Asian Woman Association 3",
    openDates: "Mon - Fri",
    description: servicesHtmlDescription,
    tag: "Services",
  },
  {
    id: "0004",
    type: "Service",
    title: "American Asian Woman Association 4",
    openDates: "Mon - Fri",
    description: servicesHtmlDescription,
    tag: "Services",
  },
  {
    id: "0005",
    type: "Service",
    title: "American Asian Woman Association 5",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: null,
  },
  {
    id: "0006",
    type: "Service",
    title: "American Asian Woman Association 6",
    openDates: "Wed",
    description: servicesHtmlDescription,
    tag: "Services",
  },
  {
    id: "0007",
    type: "Service",
    title: "American Asian Woman Association 7",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: "Public",
  },
  {
    id: "0008",
    type: "Service",
    title: "American Asian Woman Association 8",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: "Public",
  },
  {
    id: "0009",
    type: "Service",
    title: "American Asian Woman Association 9",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: "Public",
  },
  {
    id: "0010",
    type: "Service",
    title: "American Asian Woman Association 10",
    openDates: "Mon - Sun",
    description: servicesHtmlDescription,
    tag: "Public",
  },
];

//TODO: This is being used now. Should we switch and get this from the BE?
export const MembershipDogTermsDummy = {
  title: "Dog Park Rules & Regulations (E-Signature)",
  detailHtml:
    "<p>Applies to:</p> <p>(Name) for LWR Dog Park Membership (Non-Residents) Your membership fee includes the use of a key fob to access the paw parks and restrooms at Bob Gardner Park and Greenbrook Adventure Park. The annual fee is $50.00 (LWR Resident) and $100.00 (Non-Resident). Your membership will begin immediately upon activation/renewal and continue for one full year. Please renew your membership before your yearly renewal is due to prevent deactivation of your fob. <strong>Town Hall/Town Hall North must be in receipt of a current rabies vaccination certificate at all times, which may be emailed to lwrdogparks@lakewoodranch.com</strong></p> <p>*Adventure Park will be closed from 12-3 pm every Thursday for mowing & maintenance.</p> <p><strong>Paw Park Rules</strong></p> 1. This park is for the enjoyment of our canine visitors.<br /> 2. Dogs must wear current County tags and have a current rabies vaccination. <br /> 3. Dogs must be leashed when entering and exiting the park.<br /> 4. All dogs within the fence must be off-leash.<br /> 5. Aggressive dogs will not be allowed to remain in the park.<br /> 6. Dogs must be under voice control at all times (i.e. they should come when called by their owners).<br /> 7. Owners must be present with leash and in view of their dog at all times.<br /> 8. Dog feces must be picked up and disposed of by owner.<br /> 9. Owner must immediately fill in any holes dug by their dogs.<br /> 10. People food is prohibited inside the park.<br /> 11. The small dog area is recommended for small, fragile or elderly canine visitors.<br /> 12. In all cases, owners are responsible for the actions of their dogs.<br /> 13. Canine and human visitors enter at their own risk. Lakewood Ranch Community Development District 4/Lakewood Ranch Stewardship District cannot be responsible for injuries to visiting dogs, their owners, or others using the park.<br /> 14. Aggressive dogs and dogs in heat are not allowed in the park.<br /> <p>Park Hours are Dawn to Dusk & No Park Staff are on Duty in the Paw Park.</p> AMENITIES<br /> • Size (3 acres)<br /> • Separate Small Dog/Puppy Area<br /> • Time out area<br /> • Fencing (6 feet high)<br /> • Dog Drinking Fountain<br /> • Trash cans & Holders<br /> • Dispensers & Bags<br /> • Benches<br />",
};
